<template functional>
  <svg
    class="undo-icon"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMin"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <filter
      id="filter0"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
      height="112.116"
      width="98.755"
      x="17.245"
      y="4.884"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="8" />
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
      <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
    </filter>
    <g filter="url(#filter0)">
      <path
        d="M56 21.289c0-2.062-2.429-3.164-3.98-1.806l-17.956 15.71a2.4 2.4 0 000 3.613L52.02 54.517c1.551 1.358 3.98.256 3.98-1.806V43h10c12.15 0 22 9.85 22 22s-9.85 22-22 22a6 6 0 000 12c18.778 0 34-15.222 34-34S84.778 31 66 31H56z"
        fill="#fff"
      />
    </g>
    <path
      clip-rule="evenodd"
      d="M32.747 33.689l17.955-15.711c2.846-2.49 7.298-.47 7.298 3.311V29h8c19.882 0 36 16.118 36 36s-16.118 36-36 36a8 8 0 110-16c11.046 0 20-8.954 20-20s-8.954-20-20-20h-8v7.71c0 3.781-4.452 5.802-7.298 3.312l-17.955-15.71a4.4 4.4 0 010-6.623zM56 43h10c12.15 0 22 9.85 22 22s-9.85 22-22 22a6 6 0 000 12c18.778 0 34-15.222 34-34S84.778 31 66 31H56v-9.711c0-2.062-2.429-3.164-3.98-1.806l-17.956 15.71a2.4 2.4 0 000 3.613L52.02 54.517c1.551 1.358 3.98.256 3.98-1.806z"
      fill="#000"
      fill-opacity=".2"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'UndoIcon',
};
</script>

<style scoped>
.undo-icon {
  height: 100%;
  width: 100%;
}
svg path {
  fill: rgb(206, 212, 218);
}
</style>
